<template>
    <section class="row hero section-global">
        <div class="static-pages">
            <div class="static-pages-title ">
                <div class="container">
                    <div class="content-holder">
                        <div class="intro-image">
                            <img :src="sectionData.logo_url" class="img-response-w">
                        </div>
                        <div class="text-wrapper-mid">
                            <h1 class="text-white" v-html="sectionData.title"></h1>
                            <h3 class="text-white m-t">{{ sectionData.body | stripTags }}</h3>
                            <div class="row">
                                <div class="col-xs-12 col-md-5">
                                    <a @click="$emit('scroll-to', sectionData.landing_page_buttons[0].url)" href="#" class="btn btn-green btn-block m-y-md">
                                        {{ sectionData.landing_page_buttons[0].text }}
                                    </a>
                                </div>
                                <div class="col-xs-12 col-md-5">
                                    <a @click="$emit('scroll-to', sectionData.landing_page_buttons[1].url)" href="#" class="btn btn-green btn-block m-y-md">
                                        {{ sectionData.landing_page_buttons[1].text }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "HeroSection",
    props: {
        sectionData: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    mounted() {
        this.$el.style.setProperty("--hero-background", `url(${this.sectionData.background_url})`);
    }
}
</script>

<style lang="scss">
.pc-rental {
    .hero {
        --hero-background: url("");
        background-color: rgba(47, 47, 47, 0.95);
        position: relative;

        @media screen and (max-width: 1200px) {
            .btn {
                margin: 0;
            }

            .btn:first-child {
                margin-bottom: 10px;
            }

            h1 {
                font-size: 36px !important;
            }

            h3 {
                margin-top: 5px;
                margin-bottom: 40px;
            }
        }
    }

    .hero:before,
    .hero:after {
        content: "";
        position: absolute;
        background-image: var(--hero-background);
        display: block;
        background-size: cover;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
</style>
